import { get, ref } from "firebase/database";
import { database } from "../../../../Utils/firebase";
import * as actionType from "../../../../context/actions";

const GetAssignerUserExpenseData = async (state, dispatch, sharedBusinesses = null) => {
    const owners = sharedBusinesses || state?.ASSIGNERUSERBUSINESSES || [];

    if (!owners.length) return [];

    try {
        const sharedExpenses = [];

        const ownerPromises = owners.map(async (owner) => {
            const ownerUid = owner.ownerUid;
            const companies = owner.companies || [];

            // Gather all allowed company IDs for this specific owner
            const allowedCompanyIds = companies.map(company => company.companyId || company.businessId || company.id);

            if (!allowedCompanyIds.length) return;

            const expenseRef = ref(database, `invoiceGenerator/users/${ownerUid}/expense`);
            const snapshot = await get(expenseRef);

            if (!snapshot.exists()) return;

            const data = snapshot.val();

            // 🔥 Extract active expenses for allowed companies
            Object.entries(data).forEach(([uniqueID, expenseData]) => {
                if (!expenseData?.isDeleted && allowedCompanyIds.includes(expenseData.companyId)) {
                    sharedExpenses.push({
                        uniqueID,
                        ownerUid,
                        ...expenseData,
                        isShared: true
                    });
                }
            });
        });

        await Promise.all(ownerPromises);

        return sharedExpenses;

    } catch (error) {
        console.error("Firebase AssignerUser Expense Fetch Error:", error);
        return [];
    }
};

export default GetAssignerUserExpenseData;
